import { EmployeeSection } from '../../components/EmployeeSection';
import { Select } from '@welbe/design-system';
import { useEffect, useState } from 'react';
import { getInsurance } from 'services/filters';
import { useEmployee } from '../../Employee.hooks';
import { Controller } from 'react-hook-form';

export const Insurance = ({
	error,
	disabled,
}: {
	error: boolean;
	disabled?: boolean;
}) => {
	const { methods } = useEmployee();
	const { control } = methods;
	const [loadingInsurance, setLoadingInsurance] = useState(false);
	const [insurances, setInsurances] = useState([]);

	const fetchInsurance = async (): Promise<void> => {
		setLoadingInsurance(true);
		try {
			const { data } = await getInsurance();
			const { insurances } = data.content;
			setInsurances(insurances);
		} catch (error) {
			console.error(error);
		} finally {
			setLoadingInsurance(false);
		}
	};

	useEffect(() => {
		fetchInsurance();
	}, []);

	return (
		<EmployeeSection
			id="insurance"
			title="Membresía"
			description="Selecciona la membresía que estará asociada al colaborador"
		>
			<Controller
				name="insuranceId"
				control={control}
				render={({ field }) => (
					<Select.Snippet
						loading={loadingInsurance}
						disabled={loadingInsurance}
						options={insurances}
						readOnly={disabled}
						label="Membresía"
						required
						invalid={error && !field.value}
						errorText="Seleccione una membresía"
						placeholder="Selecciona una membresía"
						value={field.value ? [field.value] : undefined}
						onValueChange={(value: any) => {
							field.onChange(value ? value.id : null);
						}}
					/>
				)}
			/>
		</EmployeeSection>
	);
};
